const translations = {
  en: {
    work: 'WORK',
    rest: 'REST',
    prepare: 'Prepare',
    ready: 'READY',
    countdown: 'GET READY',
    start: 'START',
    reset: 'RESET',
    resetConfirmTitle: 'Confirm Reset',
    resetConfirmMessage: 'Are you sure you want to reset the timer?',
    save: 'Save Profile',
    workTime: 'Work Time',
    restTime: 'Rest Time',
    rounds: 'Rounds',
    startupTime: 'Startup Time',
    workTimeTooltip: 'Set the duration of the active workout interval (in seconds)',
    restTimeTooltip: 'Set the duration of the recovery interval between rounds (in seconds)',
    roundsTooltip: 'Set how many work/rest cycles you want to complete',
    startupTimeTooltip: 'Set the countdown before starting (in seconds)',
    configSaved: 'Configuration saved',
    configLoaded: 'Configuration loaded',
    workoutComplete: 'Workout complete!',
    completedRounds: 'You completed {rounds} rounds!',
    round: 'Round: {current} / {total}',
    pause: 'PAUSE',
    resume: 'RESUME',
    resetConfirmTitle: 'Confirm Reset',
    resetConfirmMessage: 'Are you sure you want to reset the timer?',
    about: 'About',
    aboutTitle: 'About Workout Timer',
    aboutText: 'This App is free and is created and published by blograffo.net which holds all copyright rights.',
    usageTitle: 'User Guide',
    usageText: 'Set work and rest times, choose rounds and start! In the Icons section you can download new sets and customize the exercise sequence.',
    usageGuideTitle: 'Complete Guide',
    usageGuideWorkTime: 'Work Time: The duration of the exercise to perform (in seconds).',
    usageGuideRestTime: 'Rest Time: The duration of the interval between one exercise and the next (in seconds).',
    usageGuideRounds: 'Rounds: The number of repetitions of the work/rest cycle.',
    usageGuideIcons: 'Icons: You can add representative icons for each round\'s exercise. Icons must first be downloaded from the "Download Icons" section and then selected in the sequence.',
    usageGuideIconText: 'Icon Text: You can modify the icon text to remember the specific exercise.',
    usageGuideSave: 'Saving: All customizations (times, rounds, icons) can be saved as a profile. Saved profiles appear as buttons at the top and can be recalled with a click.',
    usageGuideDelete: 'Deletion: Saved profiles can be deleted with a long press on the profile button.',
    usageGuideFullscreen: 'Fullscreen Mode: Double-click on the timer container to activate fullscreen mode. Double-click again to exit. A visual indicator shows when fullscreen is active.',
    usageGuideRestTimeVariable: 'Variable Rest Time: Allows you to configure different rest times for specific rounds. For example, after 4 rounds rest for 40 seconds, or every 3 rounds rest for 30 seconds. Useful for progressive workouts where recovery time needs to increase as fatigue accumulates.',
    startupTimeMenu: 'Preparation Time',
    startupTimeMenuTooltip: 'Set the countdown time before the session starts',
    startupTimeDialogTitle: 'Preparation Time',
    startupTimeDialogLabel: 'Set countdown time (seconds)',
    startupTimeDialogSave: 'Save',
    startupTimeDialogCancel: 'Cancel',
    saveProfileNameTitle: 'Save Profile',
    saveProfileNameLabel: 'Profile name (optional)',
    saveProfileNamePlaceholder: 'e.g., Tabata, HIIT, Cardio...',
    version: 'Version 0.52.00',
    copyright: '© 2023-{year} blograffo.net',
    installApp: 'Install App',
    installTitle: 'Install Workout Timer',
    installIosIntro: 'To install this app on your Home screen:',
    installIosStep1: 'Tap the Share icon at the bottom',
    installIosStep2: 'Select "Add to Home Screen"',
    installIosStep3: 'Confirm "Add"',
    installIosTip: 'The Share icon is at the bottom center (Safari) or top right.',
    installAndroid: 'Use the "Install" button in your browser menu.',
    installAndroidTip: 'Look for the "Install" or "Add to Home" icon in the browser menu (⋮).',
    installDesktop: 'Click the install icon in the address bar.',
    installDesktopTip: 'In Chrome or Edge, look for the install icon (⊕ or 💻) in the address bar on the right.',
    installDesktopTip: 'In Chrome or Edge, look for the install icon (⊕ or 💻) in the address bar on the right.',
    installGeneric: 'Use your browser menu to install this app.',
    installClose: 'Close',
    keepScreenOn: 'Keep Screen On',
    sound: 'Sound',
    shareText: 'Workout Timer - Free timer for HIIT, Tabata, and Gym workouts',
    shareTitle: 'Workout Timer',
    shareWhatsApp: 'Share on WhatsApp',
    shareFacebook: 'Share on Facebook',
    shareInstagram: 'Share on Instagram',
    shareTelegram: 'Share on Telegram',
    shareGeneric: 'Share',
    shareInstagramToast: 'Copy the link and paste it in your story or post!',
    linkCopied: 'Link copied!',
    linkCopiedDesc: 'The link has been copied to clipboard',
    shareError: 'Error',
    shareErrorDesc: 'Unable to copy link',
    fullscreenActive: 'Fullscreen',
    restTimeVariable: 'Variable Rest Time',
    restTimeVariableDesc: 'Configure different rest times for specific rounds',
    rule: 'Rule',
    removeRule: 'Remove Rule',
    ruleType: 'Type',
    ruleTypeAfter: 'After Round X',
    ruleTypeEvery: 'Every N Rounds',
    ruleTypeSpecific: 'Specific Rounds',
    ruleAfterRound: 'After Round',
    ruleEveryInterval: 'Every N Rounds',
    ruleSpecificRounds: 'Rounds (e.g., 1, 3, 5)',
    ruleRestTime: 'Rest Time (s)',
    addRule: 'Add Rule',
    restTimeSummary: 'Rest Time Summary'
  },
  it: {
    work: 'LAVORO',
    rest: 'RIPOSO',
    prepare: 'Prepara',
    ready: 'PRONTO',
    countdown: 'PREPARATI',
    start: 'INIZIA',
    reset: 'RESET',
    resetConfirmTitle: 'Conferma Reset',
    resetConfirmMessage: 'Sei sicuro di voler resettare il timer?',
    save: 'Salva profilo',
    workTime: 'Tempo di lavoro',
    restTime: 'Tempo di riposo',
    rounds: 'Round',
    startupTime: 'Tempo di avvio',
    workTimeTooltip: 'Imposta la durata dell\'intervallo di allenamento attivo (in secondi)',
    restTimeTooltip: 'Imposta la durata dell\'intervallo di recupero tra i round (in secondi)',
    roundsTooltip: 'Imposta quanti cicli di lavoro/riposo vuoi completare',
    startupTimeTooltip: 'Imposta il conto alla rovescia prima di iniziare (in secondi)',
    configSaved: 'Configurazione salvata',
    configLoaded: 'Configurazione caricata',
    workoutComplete: 'Allenamento completato!',
    completedRounds: 'Hai completato {rounds} round!',
    round: 'Round: {current} / {total}',
    pause: 'PAUSA',
    resume: 'RIPRENDI',
    about: 'Informazioni',
    aboutTitle: 'Informazioni App',
    aboutText: 'Questa App è gratuita ed è realizzata e pubblicata da blograffo.net che ne detiene tutti i diritti di copyright.',
    usageTitle: 'Guida all\'uso',
    usageText: 'Imposta i tempi di lavoro e riposo, scegli i round e avvia! Nella sezione Icone puoi scaricare nuovi set e personalizzare la sequenza degli esercizi.',
    usageGuideTitle: 'Guida Completa',
    usageGuideWorkTime: 'Tempo di lavoro: La durata dell\'esercizio da compiere (in secondi).',
    usageGuideRestTime: 'Tempo di riposo: La durata dell\'intervallo tra un esercizio e l\'altro (in secondi).',
    usageGuideRounds: 'Round: Il numero di ripetizioni del ciclo lavoro/riposo.',
    usageGuideIcons: 'Icone: Puoi aggiungere icone rappresentative dell\'esercizio per ogni round. Le icone devono essere prima scaricate dalla sezione "Download Icone" e poi selezionate nella sequenza.',
    usageGuideIconText: 'Testo icone: È possibile modificare il testo delle icone per ricordare l\'esercizio specifico.',
    usageGuideSave: 'Salvataggio: Tutte le personalizzazioni (tempi, round, icone) possono essere salvate come profilo. I profili salvati appaiono come pulsanti in alto e possono essere richiamati con un click.',
    usageGuideDelete: 'Eliminazione: I profili salvati possono essere eliminati con un click lungo sul pulsante del profilo.',
    usageGuideFullscreen: 'Modalità Schermo Intero: Fai doppio click sul container del timer per attivare la modalità schermo intero. Fai doppio click di nuovo per uscire. Un indicatore visivo mostra quando la modalità schermo intero è attiva.',
    usageGuideRestTimeVariable: 'Riposo Variabile: Permette di configurare tempi di riposo diversi per round specifici. Ad esempio, dopo 4 round riposa per 40 secondi, oppure ogni 3 round riposa per 30 secondi. Utile per allenamenti progressivi dove il tempo di recupero deve aumentare man mano che la fatica si accumula.',
    startupTimeMenu: 'Tempo di preparazione',
    startupTimeMenuTooltip: 'Imposta il tempo di countdown prima dell\'inizio della sessione',
    startupTimeDialogTitle: 'Tempo di Preparazione',
    startupTimeDialogLabel: 'Imposta il tempo di countdown (secondi)',
    startupTimeDialogSave: 'Salva',
    startupTimeDialogCancel: 'Annulla',
    version: 'Versione 0.52.00',
    copyright: '© 2023-{year} blograffo.net',
    installApp: 'Installa App',
    installTitle: 'Installa Workout Timer',
    installIosIntro: 'Per installare questa app sulla tua schermata Home:',
    installIosStep1: 'Tocca l\'icona Condividi in basso',
    installIosStep2: 'Seleziona "Aggiungi a Home"',
    installIosStep3: 'Conferma "Aggiungi"',
    installIosTip: 'L\'icona Condividi si trova in basso al centro (Safari) o in alto a destra.',
    installAndroid: 'Usa il pulsante "Installa" nel menu del browser.',
    installAndroidTip: 'Cerca l\'icona "Installa" o "Aggiungi a Home" nel menu del browser (⋮).',
    installDesktop: 'Clicca sull\'icona di installazione nella barra degli indirizzi.',
    installDesktopTip: 'In Chrome o Edge, cerca l\'icona di installazione (⊕ o 💻) nella barra degli indirizzi a destra.',
    installDesktopTip: 'In Chrome o Edge, cerca l\'icona di installazione (⊕ o 💻) nella barra degli indirizzi a destra.',
    installGeneric: 'Usa il menu del tuo browser per installare questa app.',
    installClose: 'Chiudi',
    keepScreenOn: 'Mantieni Schermo Attivo',
    sound: 'Suono',
    shareText: 'Workout Timer - Timer gratuito per allenamenti HIIT, Tabata e Palestra',
    shareTitle: 'Workout Timer',
    shareWhatsApp: 'Condividi su WhatsApp',
    shareFacebook: 'Condividi su Facebook',
    shareInstagram: 'Condividi su Instagram',
    shareTelegram: 'Condividi su Telegram',
    shareGeneric: 'Condividi',
    shareInstagramToast: 'Copia il link e incollalo nella tua storia o post!',
    linkCopied: 'Link copiato!',
    linkCopiedDesc: 'Il link è stato copiato negli appunti',
    shareError: 'Errore',
    shareErrorDesc: 'Impossibile copiare il link',
    fullscreenActive: 'Schermo Intero',
    restTimeVariable: 'Riposo Variabile',
    restTimeVariableDesc: 'Configura tempi di riposo diversi per round specifici',
    rule: 'Regola',
    removeRule: 'Rimuovi Regola',
    ruleType: 'Tipo',
    ruleTypeAfter: 'Dopo Round X',
    ruleTypeEvery: 'Ogni N Round',
    ruleTypeSpecific: 'Round Specifici',
    ruleAfterRound: 'Dopo Round',
    ruleEveryInterval: 'Ogni N Round',
    ruleSpecificRounds: 'Round (es: 1, 3, 5)',
    ruleRestTime: 'Tempo Riposo (s)',
    addRule: 'Aggiungi Regola',
    restTimeSummary: 'Riepilogo Tempi di Riposo'
  },
  de: {
    work: 'TRAINING',
    rest: 'PAUSE',
    prepare: 'Bereite vor',
    ready: 'BEREIT',
    countdown: 'MACH DICH BEREIT',
    start: 'START',
    reset: 'ZURÜCKSETZEN',
    save: 'Speichern',
    workTime: 'Trainingszeit',
    restTime: 'Pausenzeit',
    rounds: 'Runden',
    startupTime: 'Startzeit',
    workTimeTooltip: 'Legen Sie die Dauer des aktiven Trainingsintervalls fest (in Sekunden)',
    restTimeTooltip: 'Legen Sie die Dauer des Erholungsintervalls zwischen den Runden fest (in Sekunden)',
    roundsTooltip: 'Legen Sie fest, wie viele Trainings-/Pausenzyklen Sie absolvieren möchten',
    startupTimeTooltip: 'Legen Sie den Countdown vor dem Start fest (in Sekunden)',
    configSaved: 'Konfiguration gespeichert',
    configLoaded: 'Konfiguration geladen',
    workoutComplete: 'Training abgeschlossen!',
    completedRounds: 'Sie haben {rounds} Runden absolviert!',
    round: 'Runde: {current} / {total}',
    pause: 'PAUSE',
    resume: 'FORTSETZEN',
    resetConfirmTitle: 'Zurücksetzen bestätigen',
    resetConfirmMessage: 'Sind Sie sicher, dass Sie den Timer zurücksetzen möchten?',
    about: 'Über',
    aboutTitle: 'Über Workout Timer',
    aboutText: 'Diese App ist kostenlos und wird von blograffo.net erstellt und veröffentlicht, das alle Urheberrechte besitzt.',
    usageTitle: 'Anleitung',
    usageText: 'Stellen Sie Arbeits- und Ruhezeiten ein, wählen Sie Runden und starten Sie! Im Bereich Symbole können Sie neue Sets herunterladen und die Übungsreihenfolge anpassen.',
    usageGuideTitle: 'Vollständige Anleitung',
    usageGuideWorkTime: 'Trainingszeit: Die Dauer der auszuführenden Übung (in Sekunden).',
    usageGuideRestTime: 'Pausenzeit: Die Dauer des Intervalls zwischen einer Übung und der nächsten (in Sekunden).',
    usageGuideRounds: 'Runden: Die Anzahl der Wiederholungen des Trainings-/Pausenzylus.',
    usageGuideIcons: 'Symbole: Sie können repräsentative Symbole für die Übung jeder Runde hinzufügen. Symbole müssen zuerst im Bereich "Symbole herunterladen" heruntergeladen und dann in der Sequenz ausgewählt werden.',
    usageGuideIconText: 'Symboltext: Sie können den Symboltext ändern, um sich an die spezifische Übung zu erinnern.',
    usageGuideSave: 'Speichern: Alle Anpassungen (Zeiten, Runden, Symbole) können als Profil gespeichert werden. Gespeicherte Profile erscheinen als Schaltflächen oben und können mit einem Klick abgerufen werden.',
    usageGuideDelete: 'Löschen: Gespeicherte Profile können durch langes Drücken auf die Profilschaltfläche gelöscht werden.',
    usageGuideFullscreen: 'Vollbildmodus: Doppelklicken Sie auf den Timer-Container, um den Vollbildmodus zu aktivieren. Doppelklicken Sie erneut, um zu beenden. Ein visueller Indikator zeigt an, wenn der Vollbildmodus aktiv ist.',
    usageGuideRestTimeVariable: 'Variable Ruhezeit: Ermöglicht es Ihnen, unterschiedliche Ruhezeiten für bestimmte Runden zu konfigurieren. Zum Beispiel nach 4 Runden 40 Sekunden ruhen oder alle 3 Runden 30 Sekunden ruhen. Nützlich für progressive Workouts, bei denen die Erholungszeit mit zunehmender Ermüdung steigen muss.',
    startupTimeMenu: 'Vorbereitungszeit',
    startupTimeMenuTooltip: 'Stellen Sie die Countdown-Zeit vor Beginn der Sitzung ein',
    startupTimeDialogTitle: 'Vorbereitungszeit',
    startupTimeDialogLabel: 'Countdown-Zeit einstellen (Sekunden)',
    startupTimeDialogSave: 'Speichern',
    startupTimeDialogCancel: 'Abbrechen',
    saveProfileNameTitle: 'Profil speichern',
    saveProfileNameLabel: 'Profilname (optional)',
    saveProfileNamePlaceholder: 'z.B. Tabata, HIIT, Cardio...',
    version: 'Version 0.52.00',
    copyright: '© 2023-{year} blograffo.net',
    installApp: 'App installieren',
    installTitle: 'Workout Timer installieren',
    installIosIntro: 'So installieren Sie diese App auf Ihrem Startbildschirm:',
    installIosStep1: 'Tippen Sie auf das Teilen-Symbol unten',
    installIosStep2: 'Wählen Sie "Zum Home-Bildschirm"',
    installIosStep3: 'Bestätigen Sie "Hinzufügen"',
    installIosTip: 'Das Teilen-Symbol befindet sich unten in der Mitte (Safari) oder oben rechts.',
    installAndroid: 'Verwenden Sie die Schaltfläche "Installieren" im Browsermenü.',
    installAndroidTip: 'Suchen Sie nach dem Symbol "Installieren" oder "Zum Startbildschirm hinzufügen" im Browsermenü (⋮).',
    installDesktop: 'Klicken Sie auf das Installationssymbol in der Adressleiste.',
    installDesktopTip: 'In Chrome oder Edge finden Sie das Installationssymbol (⊕ oder 💻) rechts in der Adressleiste.',
    installGeneric: 'Verwenden Sie Ihr Browsermenü, um diese App zu installieren.',
    installClose: 'Schließen',
    keepScreenOn: 'Bildschirm aktiv halten',
    sound: 'Ton',
    shareText: 'Workout Timer - Kostenloser Timer für HIIT, Tabata und Fitness-Workouts',
    shareTitle: 'Workout Timer',
    shareWhatsApp: 'Auf WhatsApp teilen',
    shareFacebook: 'Auf Facebook teilen',
    shareInstagram: 'Auf Instagram teilen',
    shareTelegram: 'Auf Telegram teilen',
    shareGeneric: 'Teilen',
    shareInstagramToast: 'Kopieren Sie den Link und fügen Sie ihn in Ihre Story oder Ihren Beitrag ein!',
    linkCopied: 'Link kopiert!',
    linkCopiedDesc: 'Der Link wurde in die Zwischenablage kopiert',
    shareError: 'Fehler',
    shareErrorDesc: 'Link konnte nicht kopiert werden',
    fullscreenActive: 'Vollbild',
    restTimeVariable: 'Variable Ruhezeit',
    restTimeVariableDesc: 'Konfigurieren Sie unterschiedliche Ruhezeiten für bestimmte Runden',
    rule: 'Regel',
    removeRule: 'Regel Entfernen',
    ruleType: 'Typ',
    ruleTypeAfter: 'Nach Runde X',
    ruleTypeEvery: 'Alle N Runden',
    ruleTypeSpecific: 'Bestimmte Runden',
    ruleAfterRound: 'Nach Runde',
    ruleEveryInterval: 'Alle N Runden',
    ruleSpecificRounds: 'Runden (z.B. 1, 3, 5)',
    ruleRestTime: 'Ruhezeit (s)',
    addRule: 'Regel Hinzufügen',
    restTimeSummary: 'Ruhezeit-Zusammenfassung'
  },
  fr: {
    work: 'TRAVAIL',
    rest: 'REPOS',
    prepare: 'Prépare',
    ready: 'PRÊT',
    countdown: 'PRÉPAREZ-VOUS',
    start: 'DÉMARRER',
    reset: 'RÉINITIALISER',
    save: 'Enregistrer',
    workTime: 'Temps de travail',
    restTime: 'Temps de repos',
    rounds: 'Séries',
    startupTime: 'Temps de démarrage',
    workTimeTooltip: 'Définir la durée de l\'intervalle d\'entraînement actif (en secondes)',
    restTimeTooltip: 'Définir la durée de l\'intervalle de récupération entre les séries (en secondes)',
    roundsTooltip: 'Définir le nombre de cycles travail/repos à effectuer',
    startupTimeTooltip: 'Définir le compte à rebours avant de commencer (en secondes)',
    configSaved: 'Configuration enregistrée',
    configLoaded: 'Configuration chargée',
    workoutComplete: 'Entraînement terminé !',
    completedRounds: 'Vous avez terminé {rounds} séries !',
    round: 'Série : {current} / {total}',
    pause: 'PAUSE',
    resume: 'REPRENDRE',
    resetConfirmTitle: 'Confirmer la réinitialisation',
    resetConfirmMessage: 'Êtes-vous sûr de vouloir réinitialiser le minuteur?',
    about: 'À propos',
    aboutTitle: 'À propos de Workout Timer',
    aboutText: 'Cette application est gratuite et créée et publiée par blograffo.net qui détient tous les droits d\'auteur.',
    usageTitle: 'Guide d\'utilisation',
    usageText: 'Définissez les temps de travail et de repos, choisissez les séries et démarrez ! Dans la section Icônes, vous pouvez télécharger de nouveaux ensembles et personnaliser la séquence d\'exercices.',
    usageGuideTitle: 'Guide Complet',
    usageGuideWorkTime: 'Temps de travail: La durée de l\'exercice à effectuer (en secondes).',
    usageGuideRestTime: 'Temps de repos: La durée de l\'intervalle entre un exercice et le suivant (en secondes).',
    usageGuideRounds: 'Séries: Le nombre de répétitions du cycle travail/repos.',
    usageGuideIcons: 'Icônes: Vous pouvez ajouter des icônes représentatives de l\'exercice pour chaque série. Les icônes doivent d\'abord être téléchargées dans la section "Télécharger les icônes" puis sélectionnées dans la séquence.',
    usageGuideIconText: 'Texte des icônes: Vous pouvez modifier le texte des icônes pour vous rappeler l\'exercice spécifique.',
    usageGuideSave: 'Sauvegarde: Toutes les personnalisations (temps, séries, icônes) peuvent être sauvegardées comme profil. Les profils sauvegardés apparaissent comme boutons en haut et peuvent être rappelés d\'un clic.',
    usageGuideDelete: 'Suppression: Les profils sauvegardés peuvent être supprimés avec un appui long sur le bouton du profil.',
    usageGuideFullscreen: 'Mode Plein Écran: Double-cliquez sur le conteneur du minuteur pour activer le mode plein écran. Double-cliquez à nouveau pour quitter. Un indicateur visuel montre quand le mode plein écran est actif.',
    usageGuideRestTimeVariable: 'Temps de Repos Variable: Permet de configurer différents temps de repos pour des rounds spécifiques. Par exemple, après 4 rounds, reposez-vous pendant 40 secondes, ou tous les 3 rounds, reposez-vous pendant 30 secondes. Utile pour les entraînements progressifs où le temps de récupération doit augmenter à mesure que la fatigue s\'accumule.',
    startupTimeMenu: 'Temps de préparation',
    startupTimeMenuTooltip: 'Définir le temps de compte à rebours avant le début de la session',
    startupTimeDialogTitle: 'Temps de Préparation',
    startupTimeDialogLabel: 'Définir le temps de compte à rebours (secondes)',
    startupTimeDialogSave: 'Enregistrer',
    startupTimeDialogCancel: 'Annuler',
    saveProfileNameTitle: 'Enregistrer le profil',
    saveProfileNameLabel: 'Nom du profil (optionnel)',
    saveProfileNamePlaceholder: 'Ex: Tabata, HIIT, Cardio...',
    version: 'Version 0.52.00',
    copyright: '© 2023-{year} blograffo.net',
    installApp: 'Installer l\'app',
    installTitle: 'Installer Workout Timer',
    installIosIntro: 'Pour installer cette app sur votre écran d\'accueil :',
    installIosStep1: 'Appuyez sur l\'icône Partager en bas',
    installIosStep2: 'Sélectionnez "Sur l\'écran d\'accueil"',
    installIosStep3: 'Confirmez "Ajouter"',
    installIosTip: 'L\'icône Partager se trouve en bas au centre (Safari) ou en haut à droite.',
    installAndroid: 'Utilisez le bouton "Installer" dans le menu de votre navigateur.',
    installAndroidTip: 'Recherchez l\'icône "Installer" ou "Ajouter à l\'écran d\'accueil" dans le menu du navigateur (⋮).',
    installDesktop: 'Cliquez sur l\'icône d\'installation dans la barre d\'adresse.',
    installDesktopTip: 'Dans Chrome ou Edge, recherchez l\'icône d\'installation (⊕ ou 💻) dans la barre d\'adresse à droite.',
    installGeneric: 'Utilisez le menu de votre navigateur pour installer cette app.',
    installClose: 'Fermer',
    keepScreenOn: 'Garder l\'écran allumé',
    sound: 'Son',
    shareText: 'Workout Timer - Minuteur gratuit pour entraînements HIIT, Tabata et Gym',
    shareTitle: 'Workout Timer',
    shareWhatsApp: 'Partager sur WhatsApp',
    shareFacebook: 'Partager sur Facebook',
    shareInstagram: 'Partager sur Instagram',
    shareTelegram: 'Partager sur Telegram',
    shareGeneric: 'Partager',
    shareInstagramToast: 'Copiez le lien et collez-le dans votre story ou votre publication !',
    linkCopied: 'Lien copié !',
    linkCopiedDesc: 'Le lien a été copié dans le presse-papiers',
    shareError: 'Erreur',
    shareErrorDesc: 'Impossible de copier le lien',
    fullscreenActive: 'Plein Écran',
    restTimeVariable: 'Temps de Repos Variable',
    restTimeVariableDesc: 'Configurez des temps de repos différents pour des rounds spécifiques',
    rule: 'Règle',
    removeRule: 'Supprimer la Règle',
    ruleType: 'Type',
    ruleTypeAfter: 'Après le Round X',
    ruleTypeEvery: 'Tous les N Rounds',
    ruleTypeSpecific: 'Rounds Spécifiques',
    ruleAfterRound: 'Après le Round',
    ruleEveryInterval: 'Tous les N Rounds',
    ruleSpecificRounds: 'Rounds (ex: 1, 3, 5)',
    ruleRestTime: 'Temps de Repos (s)',
    addRule: 'Ajouter une Règle',
    restTimeSummary: 'Résumé des Temps de Repos'
  },
  es: {
    work: 'TRABAJO',
    rest: 'DESCANSO',
    prepare: 'Prepara',
    ready: 'LISTO',
    countdown: 'PREPÁRATE',
    start: 'COMENZAR',
    reset: 'REINICIAR',
    save: 'Guardar',
    workTime: 'Tiempo de trabajo',
    restTime: 'Tiempo de descanso',
    rounds: 'Rondas',
    startupTime: 'Tiempo de inicio',
    workTimeTooltip: 'Establece la duración del intervalo de entrenamiento activo (en segundos)',
    restTimeTooltip: 'Establece la duración del intervalo de recuperación entre rondas (en segundos)',
    roundsTooltip: 'Establece cuántos ciclos de trabajo/descanso quieres completar',
    startupTimeTooltip: 'Establece la cuenta regresiva antes de comenzar (en segundos)',
    configSaved: 'Configuración guardada',
    configLoaded: 'Configuración cargada',
    workoutComplete: '¡Entrenamiento completado!',
    completedRounds: '¡Has completado {rounds} rondas!',
    round: 'Ronda: {current} / {total}',
    pause: 'PAUSAR',
    resume: 'REANUDAR',
    resetConfirmTitle: 'Confirmar reinicio',
    resetConfirmMessage: '¿Estás seguro de que quieres reiniciar el temporizador?',
    about: 'Acerca de',
    aboutTitle: 'Acerca de Workout Timer',
    aboutText: 'Esta aplicación es gratuita y está creada y publicada por blograffo.net que posee todos los derechos de autor.',
    usageTitle: 'Guía de uso',
    usageText: '¡Establece los tiempos de trabajo y descanso, elige las rondas e inicia! En la sección Iconos puedes descargar nuevos conjuntos y personalizar la secuencia de ejercicios.',
    usageGuideTitle: 'Guía Completa',
    usageGuideWorkTime: 'Tiempo de trabajo: La duración del ejercicio a realizar (en segundos).',
    usageGuideRestTime: 'Tiempo de descanso: La duración del intervalo entre un ejercicio y el siguiente (en segundos).',
    usageGuideRounds: 'Rondas: El número de repeticiones del ciclo trabajo/descanso.',
    usageGuideIcons: 'Iconos: Puedes agregar iconos representativos del ejercicio para cada ronda. Los iconos deben descargarse primero en la sección "Descargar iconos" y luego seleccionarse en la secuencia.',
    usageGuideIconText: 'Texto de iconos: Puedes modificar el texto de los iconos para recordar el ejercicio específico.',
    usageGuideSave: 'Guardado: Todas las personalizaciones (tiempos, rondas, iconos) pueden guardarse como perfil. Los perfiles guardados aparecen como botones en la parte superior y pueden recuperarse con un clic.',
    usageGuideDelete: 'Eliminación: Los perfiles guardados pueden eliminarse con una pulsación larga en el botón del perfil.',
    usageGuideFullscreen: 'Modo Pantalla Completa: Haz doble clic en el contenedor del temporizador para activar el modo pantalla completa. Haz doble clic de nuevo para salir. Un indicador visual muestra cuando el modo pantalla completa está activo.',
    usageGuideRestTimeVariable: 'Tiempo de Descanso Variable: Permite configurar diferentes tiempos de descanso para rondas específicas. Por ejemplo, después de 4 rondas descansa durante 40 segundos, o cada 3 rondas descansa durante 30 segundos. Útil para entrenamientos progresivos donde el tiempo de recuperación debe aumentar a medida que se acumula la fatiga.',
    startupTimeMenu: 'Tiempo de preparación',
    startupTimeMenuTooltip: 'Establecer el tiempo de cuenta regresiva antes de que comience la sesión',
    startupTimeDialogTitle: 'Tiempo de Preparación',
    startupTimeDialogLabel: 'Establecer tiempo de cuenta regresiva (segundos)',
    startupTimeDialogSave: 'Guardar',
    startupTimeDialogCancel: 'Cancelar',
    saveProfileNameTitle: 'Guardar Perfil',
    saveProfileNameLabel: 'Nombre del perfil (opcional)',
    saveProfileNamePlaceholder: 'Ej: Tabata, HIIT, Cardio...',
    version: 'Versión 0.52.00',
    copyright: '© 2023-{year} blograffo.net',
    installApp: 'Instalar App',
    installTitle: 'Instalar Workout Timer',
    installIosIntro: 'Para instalar esta app en tu pantalla de inicio:',
    installIosStep1: 'Toca el icono Compartir en la parte inferior',
    installIosStep2: 'Selecciona "Añadir a pantalla de inicio"',
    installIosStep3: 'Confirma "Añadir"',
    installIosTip: 'El icono Compartir está en la parte inferior central (Safari) o superior derecha.',
    installAndroid: 'Usa el botón "Instalar" en el menú de tu navegador.',
    installAndroidTip: 'Busca el icono "Instalar" o "Añadir a inicio" en el menú del navegador (⋮).',
    installDesktop: 'Haz clic en el icono de instalación en la barra de direcciones.',
    installDesktopTip: 'En Chrome o Edge, busca el icono de instalación (⊕ o 💻) en la barra de direcciones a la derecha.',
    installGeneric: 'Usa el menú de tu navegador para instalar esta app.',
    installClose: 'Cerrar',
    keepScreenOn: 'Mantener pantalla encendida',
    sound: 'Sonido',
    shareText: 'Workout Timer - Temporizador gratuito para entrenamientos HIIT, Tabata y Gimnasio',
    shareTitle: 'Workout Timer',
    shareWhatsApp: 'Compartir en WhatsApp',
    shareFacebook: 'Compartir en Facebook',
    shareInstagram: 'Compartir en Instagram',
    shareTelegram: 'Compartir en Telegram',
    shareGeneric: 'Compartir',
    shareInstagramToast: '¡Copia el enlace y pégalo en tu historia o publicación!',
    linkCopied: '¡Enlace copiado!',
    linkCopiedDesc: 'El enlace ha sido copiado al portapapeles',
    shareError: 'Error',
    shareErrorDesc: 'No se pudo copiar el enlace',
    fullscreenActive: 'Pantalla Completa',
    restTimeVariable: 'Tiempo de Descanso Variable',
    restTimeVariableDesc: 'Configura diferentes tiempos de descanso para rondas específicas',
    rule: 'Regla',
    removeRule: 'Eliminar Regla',
    ruleType: 'Tipo',
    ruleTypeAfter: 'Después de la Ronda X',
    ruleTypeEvery: 'Cada N Rondas',
    ruleTypeSpecific: 'Rondas Específicas',
    ruleAfterRound: 'Después de la Ronda',
    ruleEveryInterval: 'Cada N Rondas',
    ruleSpecificRounds: 'Rondas (ej: 1, 3, 5)',
    ruleRestTime: 'Tiempo de Descanso (s)',
    addRule: 'Añadir Regla',
    restTimeSummary: 'Resumen de Tiempos de Descanso'
  },
  ru: {
    work: 'РАБОТА',
    rest: 'ОТДЫХ',
    ready: 'ГОТОВ',
    countdown: 'ПРИГОТОВЬТЕСЬ',
    start: 'СТАРТ',
    reset: 'СБРОС',
    save: 'Сохранить',
    workTime: 'Время работы',
    restTime: 'Время отдыха',
    rounds: 'Раунды',
    startupTime: 'Время запуска',
    workTimeTooltip: 'Установите продолжительность активного интервала тренировки (в секундах)',
    restTimeTooltip: 'Установите продолжительность интервала восстановления между раундами (в секундах)',
    roundsTooltip: 'Установите, сколько циклов работы/отдыха вы хотите выполнить',
    startupTimeTooltip: 'Установите обратный отсчет перед началом (в секундах)',
    configSaved: 'Конфигурация сохранена',
    configLoaded: 'Конфигурация загружена',
    workoutComplete: 'Тренировка завершена!',
    completedRounds: 'Вы завершили {rounds} раундов!',
    round: 'Раунд: {current} / {total}',
    pause: 'ПАУЗА',
    resume: 'ПРОДОЛЖИТЬ',
    resetConfirmTitle: 'Подтвердить сброс',
    resetConfirmMessage: 'Вы уверены, что хотите сбросить таймер?',
    about: 'О приложении',
    aboutTitle: 'О Workout Timer',
    aboutText: 'Это приложение бесплатное и создано и опубликовано blograffo.net, который владеет всеми авторскими правами.',
    usageTitle: 'Руководство пользователя',
    usageText: 'Установите время работы и отдыха, выберите раунды и начните! В разделе Иконки вы можете загрузить новые наборы и настроить последовательность упражнений.',
    usageGuideTitle: 'Полное руководство',
    usageGuideWorkTime: 'Время работы: Продолжительность выполняемого упражнения (в секундах).',
    usageGuideRestTime: 'Время отдыха: Продолжительность интервала между одним упражнением и следующим (в секундах).',
    usageGuideRounds: 'Раунды: Количество повторений цикла работа/отдых.',
    usageGuideIcons: 'Иконки: Вы можете добавить репрезентативные иконки для упражнения каждого раунда. Иконки должны быть сначала загружены в разделе "Загрузить иконки", а затем выбраны в последовательности.',
    usageGuideIconText: 'Текст иконок: Вы можете изменить текст иконок, чтобы запомнить конкретное упражнение.',
    usageGuideSave: 'Сохранение: Все настройки (времена, раунды, иконки) могут быть сохранены как профиль. Сохраненные профили отображаются как кнопки вверху и могут быть вызваны одним кликом.',
    usageGuideDelete: 'Удаление: Сохраненные профили могут быть удалены длительным нажатием на кнопку профиля.',
    usageGuideFullscreen: 'Полноэкранный режим: Дважды щелкните по контейнеру таймера, чтобы активировать полноэкранный режим. Дважды щелкните снова, чтобы выйти. Визуальный индикатор показывает, когда полноэкранный режим активен.',
    usageGuideRestTimeVariable: 'Переменное время отдыха: Позволяет настроить разное время отдыха для конкретных раундов. Например, после 4 раундов отдыхайте 40 секунд или каждые 3 раунда отдыхайте 30 секунд. Полезно для прогрессивных тренировок, где время восстановления должно увеличиваться по мере накопления усталости.',
    startupTimeMenu: 'Время подготовки',
    startupTimeMenuTooltip: 'Установить время обратного отсчета перед началом сессии',
    startupTimeDialogTitle: 'Время Подготовки',
    startupTimeDialogLabel: 'Установить время обратного отсчета (секунды)',
    startupTimeDialogSave: 'Сохранить',
    startupTimeDialogCancel: 'Отмена',
    saveProfileNameTitle: 'Сохранить профиль',
    saveProfileNameLabel: 'Имя профиля (необязательно)',
    saveProfileNamePlaceholder: 'Например: Табата, HIIT, Кардио...',
    version: 'Версия 0.52.00',
    copyright: '© 2023-{year} blograffo.net',
    installApp: 'Установить приложение',
    installTitle: 'Установить Workout Timer',
    installIosIntro: 'Чтобы установить это приложение на главный экран:',
    installIosStep1: 'Нажмите на значок Поделиться внизу',
    installIosStep2: 'Выберите "На экран Домой"',
    installIosStep3: 'Подтвердите "Добавить"',
    installIosTip: 'Значок Поделиться находится внизу по центру (Safari) или вверху справа.',
    installAndroid: 'Используйте кнопку "Установить" в меню браузера.',
    installAndroidTip: 'Найдите значок "Установить" или "Добавить на главный экран" в меню браузера (⋮).',
    installDesktop: 'Нажмите на значок установки в адресной строке.',
    installDesktopTip: 'В Chrome или Edge найдите значок установки (⊕ или 💻) в адресной строке справа.',
    installGeneric: 'Используйте меню браузера для установки этого приложения.',
    installClose: 'Закрыть',
    keepScreenOn: 'Держать экран включенным',
    sound: 'Звук',
    shareText: 'Workout Timer - Бесплатный таймер для тренировок HIIT, Tabata и тренажерного зала',
    shareTitle: 'Workout Timer',
    shareWhatsApp: 'Поделиться в WhatsApp',
    shareFacebook: 'Поделиться в Facebook',
    shareInstagram: 'Поделиться в Instagram',
    shareTelegram: 'Поделиться в Telegram',
    shareGeneric: 'Поделиться',
    shareInstagramToast: 'Скопируйте ссылку и вставьте её в свою историю или публикацию!',
    linkCopied: 'Ссылка скопирована!',
    linkCopiedDesc: 'Ссылка была скопирована в буфер обмена',
    shareError: 'Ошибка',
    shareErrorDesc: 'Не удалось скопировать ссылку',
    fullscreenActive: 'Полноэкранный режим',
    restTimeVariable: 'Переменное Время Отдыха',
    restTimeVariableDesc: 'Настройте разное время отдыха для конкретных раундов',
    rule: 'Правило',
    removeRule: 'Удалить Правило',
    ruleType: 'Тип',
    ruleTypeAfter: 'После Раунда X',
    ruleTypeEvery: 'Каждые N Раундов',
    ruleTypeSpecific: 'Конкретные Раунды',
    ruleAfterRound: 'После Раунда',
    ruleEveryInterval: 'Каждые N Раундов',
    ruleSpecificRounds: 'Раунды (например: 1, 3, 5)',
    ruleRestTime: 'Время Отдыха (с)',
    addRule: 'Добавить Правило',
    restTimeSummary: 'Сводка Времени Отдыха'
  },
  zh: {
    work: '运动',
    rest: '休息',
    prepare: '准备',
    ready: '准备',
    countdown: '准备开始',
    start: '开始',
    reset: '重置',
    save: '保存',
    workTime: '运动时间',
    restTime: '休息时间',
    rounds: '回合',
    startupTime: '启动时间',
    workTimeTooltip: '设置活动运动间隔的持续时间（秒）',
    restTimeTooltip: '设置回合之间的恢复间隔时间（秒）',
    roundsTooltip: '设置要完成的运动/休息循环次数',
    startupTimeTooltip: '设置开始前的倒计时（秒）',
    configSaved: '配置已保存',
    configLoaded: '配置已加载',
    workoutComplete: '运动完成！',
    completedRounds: '你完成了 {rounds} 个回合！',
    round: '回合：{current} / {total}',
    pause: '暂停',
    resume: '继续',
    resetConfirmTitle: '确认重置',
    resetConfirmMessage: '您确定要重置计时器吗？',
    about: '关于',
    aboutTitle: '关于 Workout Timer',
    aboutText: '此应用程序是免费的，由 blograffo.net 创建和发布，拥有所有版权。',
    usageTitle: '使用指南',
    usageText: '设置工作和休息时间，选择回合数并开始！在图标部分，您可以下载新的图标集并自定义练习顺序。',
    usageGuideTitle: '完整指南',
    usageGuideWorkTime: '运动时间：要进行的运动的持续时间（秒）。',
    usageGuideRestTime: '休息时间：一个运动与下一个运动之间的间隔时间（秒）。',
    usageGuideRounds: '回合：工作/休息循环的重复次数。',
    usageGuideIcons: '图标：您可以为每个回合的运动添加代表性图标。图标必须首先从"下载图标"部分下载，然后在序列中选择。',
    usageGuideIconText: '图标文本：您可以修改图标文本以记住特定运动。',
    usageGuideSave: '保存：所有自定义（时间、回合、图标）都可以保存为配置文件。保存的配置文件显示为顶部的按钮，可以通过单击调用。',
    usageGuideDelete: '删除：可以通过长按配置文件按钮来删除保存的配置文件。',
    usageGuideFullscreen: '全屏模式：双击计时器容器以激活全屏模式。再次双击以退出。视觉指示器显示全屏模式何时处于活动状态。',
    usageGuideRestTimeVariable: '可变休息时间：允许您为特定轮次配置不同的休息时间。例如，4轮后休息40秒，或每3轮休息30秒。适用于渐进式训练，随着疲劳累积，恢复时间需要增加。',
    startupTimeMenu: '准备时间',
    startupTimeMenuTooltip: '设置会话开始前的倒计时时间',
    startupTimeDialogTitle: '准备时间',
    startupTimeDialogLabel: '设置倒计时时间（秒）',
    startupTimeDialogSave: '保存',
    startupTimeDialogCancel: '取消',
    saveProfileNameTitle: '保存配置文件',
    saveProfileNameLabel: '配置文件名称（可选）',
    saveProfileNamePlaceholder: '例如：Tabata、HIIT、Cardio...',
    version: '版本 0.52.00',
    copyright: '© 2023-{year} blograffo.net',
    installApp: '安装应用',
    installTitle: '安装 Workout Timer',
    installIosIntro: '要将此应用安装到主屏幕：',
    installIosStep1: '点击底部的分享图标',
    installIosStep2: '选择"添加到主屏幕"',
    installIosStep3: '确认"添加"',
    installIosTip: '分享图标位于底部中央（Safari）或右上角。',
    installAndroid: '使用浏览器菜单中的"安装"按钮。',
    installAndroidTip: '在浏览器菜单（⋮）中查找"安装"或"添加到主屏幕"图标。',
    installDesktop: '点击地址栏中的安装图标。',
    installDesktopTip: '在 Chrome 或 Edge 中，在地址栏右侧查找安装图标（⊕ 或 💻）。',
    installGeneric: '使用浏览器菜单安装此应用。',
    installClose: '关闭',
    keepScreenOn: '保持屏幕开启',
    sound: '声音',
    shareText: 'Workout Timer - 免费的 HIIT、Tabata 和健身房训练计时器',
    shareTitle: 'Workout Timer',
    shareWhatsApp: '在 WhatsApp 上分享',
    shareFacebook: '在 Facebook 上分享',
    shareInstagram: '在 Instagram 上分享',
    shareTelegram: '在 Telegram 上分享',
    shareGeneric: '分享',
    shareInstagramToast: '复制链接并将其粘贴到您的故事或帖子中！',
    linkCopied: '链接已复制！',
    linkCopiedDesc: '链接已复制到剪贴板',
    shareError: '错误',
    shareErrorDesc: '无法复制链接',
    fullscreenActive: '全屏',
    restTimeVariable: '可变休息时间',
    restTimeVariableDesc: '为特定轮次配置不同的休息时间',
    rule: '规则',
    removeRule: '删除规则',
    ruleType: '类型',
    ruleTypeAfter: '第X轮之后',
    ruleTypeEvery: '每N轮',
    ruleTypeSpecific: '特定轮次',
    ruleAfterRound: '第X轮之后',
    ruleEveryInterval: '每N轮',
    ruleSpecificRounds: '轮次（例如：1, 3, 5）',
    ruleRestTime: '休息时间（秒）',
    addRule: '添加规则',
    restTimeSummary: '休息时间摘要'
  }
};

export const getTranslations = () => {
  const userLanguage = navigator.language.split('-')[0];
  return translations[userLanguage] || translations.en;
};